import { createFileRoute } from "@tanstack/react-router";
import { SheetsList } from "@/components/Sheets";

export const Route = createFileRoute("/_authenticated/financials/sheets/")({
  component: SheetsList,
  staticData: { page: "finance" },
});
